var styles = {"box":"SocialLinks_box_1fxhr_1","padding-top":"SocialLinks_padding-top_1fxhr_8","button-circle":"SocialLinks_button-circle_1fxhr_11"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
